import React, { FC } from 'react';
import {
  TypePlayKitsLandingPage,
  TypeNewsletterBlockFields,
} from '@/core/generated-types';
import { ProductContextProvider } from '@/context/ProductContext';
import { DynamicComponent } from '@/components';
import { YotpoReviewsWidget, NewsletterBlock } from '@/components';
import { Seo } from '@/components/ui/Seo';
import { buildCanonicalUrl } from '@/core/contentfulConfig';
import { useTrackPlayKitPLPProducts } from '@/hooks/useTrackPlayKitPLPProducts';

export type PlayKitsLandingPageLayoutProps = TypePlayKitsLandingPage;

export const PlayKitsLandingPageLayout: FC<PlayKitsLandingPageLayoutProps> = (
  page,
) => {
  const {
    components,
    product,
    enableYotpoReviewsSummary,
    enableYotpoReviewsWidget,
    enableTrustedShopsReviewsSummary,
    newsletterSignup,
  } = page.fields;
  const metadataFields = page.fields?.pageMetafields?.fields;

  useTrackPlayKitPLPProducts();

  return (
    <div className="playkit-lp">
      <ProductContextProvider
        value={{
          enableYotpoReviewsSummary,
          enableTrustedShopsReviewsSummary,
          product,
        }}
      >
        <Seo
          title={metadataFields?.pageTitle}
          description={metadataFields?.pageDescription}
          nofollow={metadataFields?.noFollow}
          noindex={metadataFields?.noIndex}
          canonical={buildCanonicalUrl(page)}
        />
        {components &&
          components.map((component, i) => (
            <DynamicComponent
              key={`${component.sys.id}-${i}`}
              component={component}
            />
          ))}
        {enableYotpoReviewsWidget && <YotpoReviewsWidget product={product} />}
        {newsletterSignup && (
          <NewsletterBlock
            {...(newsletterSignup.fields as unknown as TypeNewsletterBlockFields)}
          />
        )}
      </ProductContextProvider>
    </div>
  );
};
